<template>
  <div class="main">
    <div class="handle-search">
      <div class="search-box">
        <div class="searchItem">
            <el-select v-model="query.filter" multiple placeholder="请筛选" style="width:240px" @change="advertisementAccountBillList" size="small">
                <el-option v-for="(item, index) in filterDropList" :key="index" :value="item.id" :label="item.name"></el-option>
            </el-select>
        </div>
      </div>
      <el-button type="danger" size="small" icon="el-icon-back" @click="$router.go(-1)">返回</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column label="序号" width="100" align="center" type="index"></el-table-column>
      <el-table-column prop="actionTime" label="交易时间" align="center"></el-table-column>
      <el-table-column prop="actionUserAccountName" label="用户名" align="center"></el-table-column>
      <!-- <el-table-column label="服务名" align="center"></el-table-column> -->
      <!-- <el-table-column prop="balance" label="服务有效期" align="center"></el-table-column> -->
      <el-table-column prop="amount" label="当前操作（元）" align="center"></el-table-column>
      <el-table-column prop="afterAmount" label="余额（元）" align="center"></el-table-column>
      <el-table-column prop="remark" label="事由" align="center"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { GetBillFilterDropList,AdvertisementAccountBillList } from "@/utils/api";
export default {
  data() {
    return {
      tableData: [],
      filterDropList: [],
      pageTotal: 10,
      query: {
        pageStart: 1,
        limit: 10,
        filter: [],
        advertisementAccountId:Number(this.$route.query.advertisementAccountId)
      },
    };
  },
  methods: {
    // 获取用户列表
    advertisementAccountBillList() {
      AdvertisementAccountBillList(this.query).then(res => {
        if (res) {
          this.tableData = res.data;
          this.pageTotal = res.totalData;
        }
      });
    },
    // 改变分页
    handlePageChange(val) {
      this.query.pageStart = val;
      this.advertisementAccountBillList();
    },
    //获取过滤条件
    getBillFilterDropList(){
      GetBillFilterDropList().then(res=>{
        if(res){
          this.filterDropList = res;
        }
      })
    }
  },
  components: {},
  created() {
    this.advertisementAccountBillList();
    this.getBillFilterDropList();
  }
};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 10px 0;
  .handle-search {
    background: #f3f3f3;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    padding: 10px 20px;
    border-radius: 5px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    .search-box {
      .searchItem {
        input,
        select {
          width: 160px;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    margin-top: 20px;
  }
  .handle-fun {
    margin: 20px 0;
  }
  .shopList {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding-left: 60px;
    /deep/ .el-checkbox {
      margin-top: 5px;
      margin-bottom: 5px;
      width: 220px;
    }
  }
}
</style>